import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";

function getItem(data, style) {
  return (
    <div key={data.name} className="grid grid-cols-1 pb-2 px-3 font-bold">
      <div className="flex mx-auto">
        <span className={cn("text-3xl", style)}>{data.value}</span>
        <span className={cn("text-3xl pl-1", style)}>{data.icon}</span>
      </div>
    </div>
  );
}

function InfoDoubleCard({ title, elements, color }) {
  const _color = color ?? "border-amber-300";
  return (
    <div className="grid h-26 p-2 bg-neutral-50 rounded-lg border border-neutral-300 shadow-md w-54 overflow-hidden">
      <div className={cn("mx-auto py-2 text-center w-full", _color)}>
        <span className="justify-center text-xl text-neutral-400">
          <FM id={title} />
        </span>
      </div>
      <div className="flex mx-auto px-2">
        {getItem(elements[0], "text-neutral-600")}
        <span className="text-sky-400 text-xl">|</span>
        {getItem(elements[1], "text-neutral-400")}
      </div>
    </div>
  );
}

export default InfoDoubleCard;
